import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import Preloader from '@/components/UI/Preloader';
import { prettyFloatMoney } from '@/helpers/utils';
import { LoanDetails } from './components/LoanDetails';
import { FinancingAgreements } from './components/FinancingAgreements';
import { useGetLenderLoanDetail } from '@/query/queries/loan/useGetLenderLoanDetail';
import { prettyDate } from '@/helpers/date';
import { EMPTY_DASH } from '@scramble/utils';
import s from './index.module.scss';

const id = MODAL_IDS.lender_loan_detail;

export const LenderLoanDetailModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && props?.loan && <Modal {...props} />;
};

const Modal = ({ loan }) => {
  const { closeModal } = useModal();
  const { fundraising_id, amounts } = loan;

  const { data, isLoading } = useGetLenderLoanDetail(fundraising_id);
  const { t } = useTranslation();

  const content = (
    <div className={s.modal}>
      {isLoading ? (
        <Preloader className={s.preloader} />
      ) : (
        <>
          <div className={s.header}>
            <h2 className="f-h2 f-500">{t('loans:loan_info.loan')}</h2>
          </div>
          <div className={s.content}>
            <div className={s.base}>
              <div className={s.table}>
                <div className={s.thead}>
                  <div className={s.thead_col}>{t('loans:loan_info.started')}</div>
                  <div className={s.thead_col}>{t('loans:loan_info.end_date')}</div>
                  <div className={s.thead_col}>{t('loans:loan_info.loan_total')}</div>
                  <div className={s.thead_col}>{t('loans:loan_info.fpg_option')}</div>
                </div>
                <div className={s.tbody}>
                  <div className={s.tbody_row}>
                    <div className={s.tbody_col}>
                      {data ? prettyDate(data.started) : EMPTY_DASH}
                    </div>
                    <div className={s.tbody_col}>
                      {data ? prettyDate(data.end_of_grace_period) : EMPTY_DASH}
                    </div>
                    <div className={s.tbody_col}>
                      {prettyFloatMoney(amounts.total_loan_amount)}
                    </div>
                    <div className={s.tbody_col}>
                      {loan.selected_fpg ? loan.selected_fpg.title : EMPTY_DASH}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {data && (
              <>
                <LoanDetails loans={data.loans} />
                <FinancingAgreements fundraisingId={loan.fundraising_id} data={data} />
              </>
            )}
          </div>
        </>
      )}
    </div>
  );

  return (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
